export const SaleNoteStatusConfig = {
    PAYED: 'PAYED',
    PAYMENT_PENDING: 'PAYMENT_PENDING',
    CANCELLED: 'CANCELLED'
};
export const SaleNotePaymentStatusConfig = {
    PAYED: 'PAGADO',
    NOT_PAYED: 'NO PAGADO'
};